const getConsumptionValues = (data) => {
    if (typeof data !== 'object') return []
    const consumptionValues = Object.values(data)
    return consumptionValues
}

export default getConsumptionValues


